import * as React from 'react';
import {Select} from 'antd';
import furoApi from '../api/FuroApi';
import {Company, ErrorResponse} from '../api/dtos/dtos';
import {ErrorAlert} from '../common/ErrorAlert';
import accountProvider from './AccountProvider';
import locales from '../locales';

interface State {
  companies: Company[];
  loading: boolean;
  error?: ErrorResponse;
}

class CompanySelector extends React.Component<{}, State> {
  public state: State = {companies: [], loading: true};
  private mounted = false;

  public componentDidMount() {
    this.mounted = true;
    this.loadCompanies();
  }

  public componentWillUnmount() {
    this.mounted = false;
  }

  public render() {
    const {companies, loading, error} = this.state;
    return (
      <div className="company-selector">
        <Select<string>
          aria-label={locales.company_name}
          placeholder={locales.company_name}
          value={accountProvider.getSelectedCompanyId()}
          loading={loading}
          onChange={this.onCompanyChange}
        >
          {companies.map(company => (
            <Select.Option key={company.id} value={String(company.id)}>{company.name}</Select.Option>
          ))}
        </Select>
        {error && <ErrorAlert error={error}/>}
      </div>
    );
  }

  private loadCompanies = () => {
    this.setState({loading: true, error: undefined});
    furoApi.users.getMyCompanies()
      .then(companies => {
        if (!this.mounted) {
          return;
        }
        this.setState({companies, loading: false});
      })
      .catch((error: ErrorResponse) => {
        if (this.mounted) {
          this.setState({error, loading: false});
        }
      });
  };

  private onCompanyChange = (companyId: string) => {
    if (companyId !== accountProvider.getSelectedCompanyId()) {
      accountProvider.setSelectedCompanyId(companyId);
      window.location.assign('/');
    }
  };
}

export default CompanySelector;



// WEBPACK FOOTER //
// ./src/account/CompanySelector.tsx